import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import EmailInput from '../EmailInput'
import './EditContactPage.css'

const invalidInput = 'is-invalid'
const validInput = 'is-valid'

const EditContactPage = ({ contact, onDelete, onSave, onError, onCancel }) => {

  // If we have an onDelete callback the email is read-only
  const isForContactEdit = !!onDelete
  const [isDirty, setDirty] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState(false)
  const confirmDelete =(user) => {
    setShowDeleteModal(true)
  }

  const handleDelete = () => {
    setShowDeleteModal(false)
    if (onDelete) {
      // Use the original contact passed in, not the edited contact
      onDelete(contact)
    }
  }

  const cancelDelete = () => {
    setShowDeleteModal(false)
  }

  const handleSave = () => {
    if (onSave) {
      onSave(selectedContact)
    }
  }

  const handleCancel = () => {
    if (onCancel) {
      onCancel()
    }
  }

  const [selectedContact, setContact] = useState(contact)
  const formSubmit = (event) => {
    event.preventDefault()
  }

  const [emailValid, setEmailValidity] = useState(false)
  const onEmailChange = (value, isValid) => {
    setDirty(true)
    setEmailValidity(isValid)
    const newContact = {...selectedContact}
    newContact.email = value 
    setContact(newContact)
  }

  const [contactMnoValid, setMnoValidity] = useState(false)
  const [contactMnoErrorMessage, setMnoErrorMessage] = useState('')
  const handleMnoChange = (event) => {
    setDirty(true)
    const mno = event.target.value
    const newContact = {...selectedContact}
    newContact.mno = mno
    setContact(newContact)
  }

  useEffect(() => {
    let isValid = true
    if (!selectedContact?.mno) {
      setMnoErrorMessage('Required');
      isValid = false;
    }
    setMnoValidity(isValid)
  },[selectedContact?.mno])

  const [contactNameValid, setContactNameValidity] = useState(false)
  const [contactNameErrorMessage, setContactNameErrorMessage] = useState('')
  const handleContactNameChange = (event) => {
    setDirty(true)
    const contactName = event.target.value
    const newContact = {...selectedContact}
    newContact.contactName = contactName
    setContact(newContact)
  }

  useEffect(() => {
    let isValid = true
    if (!selectedContact?.contactName) {
      setContactNameErrorMessage('Required');
      isValid = false;
    }
    setContactNameValidity(isValid)
  }, [selectedContact?.contactName])

  const handleOtherContactChange = (event) => {
    setDirty(true)
    const otherContact = event.target.value
    const newContact = {...selectedContact}
    newContact.otherContact = otherContact
    setContact(newContact)
  }

  const disableSave = () => {
    if (!isDirty) {
      return true
    }

    return ((!emailValid && !isForContactEdit) || 
             !contactMnoValid ||
             !contactNameValid)
  }

  if (!contact) {
    if (onError) {
      onError()
      return null
    }
  }

  let mnoValidityClass = ''
  let contactNameValidityClass = ''
  if (isDirty) {
    mnoValidityClass = contactMnoValid?validInput:invalidInput
    contactNameValidityClass = contactNameValid?validInput:invalidInput
  }

  /*
    This component does not use a Redux form. There is no external dependency on the 
    state from this form, so keeping the state internal to this component was preferable.
    In this instance, there was no need for form submission. The form tag has only been 
    added due to some hardcoded CSS styling. 
  */
  return (
    <React.Fragment>
      { isForContactEdit &&
        <h2>Edit MNO Contact</h2>
      }
      { !isForContactEdit &&
        <h2>Create MNO Contact</h2>
      }
      <form className="edit-contact-panel" onSubmit={ formSubmit }>
      <div className="form-group">
          <label htmlFor="contactMno">MNO</label>
          <input id="contactMno" 
                 type="text" 
                 name="contactMno" 
                 className={`form-control ${mnoValidityClass}`}
                 onChange={ handleMnoChange } 
                 required 
                 value={ selectedContact?.mno } 
                 maxLength="50" 
                 aria-describedby="contact-mno-validation-message"/>
        </div>
        { !contactMnoValid && isDirty &&
          <div id="contact-mno-validation-message" 
               className="invalid-feedback"
               style={{ 
                 display: 'block',
                 marginLeft: '230px'
               }}>
            { contactMnoErrorMessage }
          </div>     
        }

        <EmailInput value={ selectedContact.email } onChange={ onEmailChange } readOnly={ isForContactEdit }/>

        <div className="form-group">
          <label htmlFor="contactName">Contact Name</label>
          <input id="contactName" 
                 type="text" 
                 name="contactName" 
                 className={`form-control ${contactNameValidityClass}`}
                 onChange={ handleContactNameChange } 
                 required 
                 value={ selectedContact?.contactName } 
                 maxLength="50" 
                 aria-describedby="contact-name-validation-message"/>
        </div>
        { !contactNameValid && isDirty &&
          <div id="contact-name-validation-message" 
               className="invalid-feedback"
               style={{ 
                 display: 'block',
                 marginLeft: '230px'
               }}>
            { contactNameErrorMessage }
          </div>     
        }

        <div className="form-group">
          <label htmlFor="otherContact">Other Contact Details</label>
          <textarea id="otherContact" 
                    type="textarea" 
                    name="otherContact" 
                    rows="4"
                    className="form-control"
                    onChange={ handleOtherContactChange } 
                    value={ selectedContact?.otherContact } 
                    maxLength="100"/>
        </div>

        <button className="float-right btn btn-primary" 
                onClick={ handleSave } 
                disabled={ disableSave() }>
          Save
        </button>
        <button className="float-right btn btn-secondary" onClick={ handleCancel }>
          Cancel
        </button>
        { onDelete && 
          <button className="float-right btn btn-danger" onClick={ confirmDelete }>
            Delete
          </button>
        }
      </form>
      { onDelete && 
        <Modal show={ showDeleteModal } onHide={ cancelDelete } >
          <Modal.Header closeButton>
            Confirm MNO Contact Deletion
          </Modal.Header>
          <Modal.Body>
            Please confirm you wish to delete contact: <code>{ contact.email }</code>
          </Modal.Body>
          <Modal.Footer>
            <button type="submit" className="btn btn-secondary" onClick={ cancelDelete } data-testid="modal-user-cancel">Cancel</button>
            <button type="submit" className="btn btn-danger" onClick={ handleDelete } data-testid="modal-user-delete">Delete</button>
          </Modal.Footer>
        </Modal>
      }
    </React.Fragment>
  )
}

export default EditContactPage